import { createReducer } from './../utils';
import { Calculate } from './../services'

const { REACT_APP_NOPRIVACY } = process.env;

const isNoPrivacy = REACT_APP_NOPRIVACY === '1';

const initialState = {
	isDisabled: true,
	isLoading: false,
	errorMessages: [],
	isNoPrivacy,
  data: {
		industry: 'Agriculture',
		averageOfWorkingDay: 5.9,
		averageSalary: 29588,
		numberOfEmployees: 1,
		totalCostPerDay: 1,
		submitForm: {
			companyName: '',
			yourName: '',
			email: '',
			phone: ''
		}
  },
	results: {
		averageCostPerYear: 0,
		averageCostPerDay: 0,
		totalCostPerDay: 0,
		annualSaving: 0
	}
};

const calculate = (data) => {
	const averageCostPerYear = Calculate.absenteeism.perYear(data.averageSalary, data.averageOfWorkingDay);
	const	averageCostPerDay = Calculate.absenteeism.perDay(data.averageSalary);
	const	totalCostPerDay = Calculate.absenteeism.annualCost(averageCostPerYear ,data.numberOfEmployees);
	const annualSaving = Calculate.absenteeism.annualSaving(totalCostPerDay, data.totalCostPerDay);
	return {
		averageCostPerYear,
		averageCostPerDay,
		totalCostPerDay,
		annualSaving
	}
};

const validate = (data = {}) => {
	const validateRules = [
		{
			fieldName: 'email',
			// eslint-disable-next-line
			rule: value => !(/^[\.\w]+@[a-z\.A-Z_]+?\.(com|co\.uk)$/).test(value),
			message: 'Please provide valid email.',
			required: !isNoPrivacy
		},
		// {
		// 	fieldName: 'email',
		// 	rule: (value = '') => value === '',
		// 	message: 'Email is required.'
		// },
		{
			fieldName: 'companyName',
			rule: (value = '') => value === '',
			message: 'Company name is required.',
			required: true
		},
		{
			fieldName: 'yourName',
			rule: (value = '') => value === '',
			message: 'First name is required.',
			required: !isNoPrivacy
		},
		{
			fieldName: 'yourLastName',
			rule: (value = '') => value === '',
			message: 'Last name is required.',
			required: !isNoPrivacy
		},
		{
			fieldName: 'phone',
			rule: (value = '') => value !== '' && !(/^\d{11}$/).test(value),
			message: 'Please provide valid phone number.',
			required: !isNoPrivacy
		}
	];
	return Object.keys(data).reduce((result, name) => {
		const errors = validateRules.reduce((messagesArr, { fieldName, rule, message, required }) => (
			fieldName === name && rule(data[name]) && required === true ? [...messagesArr, { [fieldName]: message }] : messagesArr
		), []);
		return [...result, ...errors];
	}, []);
};

const validEmail = email => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
}

const isDisabledSubmit = ({ data = {} }) => {
  const { submitForm } = data;
  const noGaps = Object.keys(submitForm).map(f => submitForm[f]).some(element => (!element));
  return noGaps || !validEmail(submitForm['email']);
}

export default createReducer(initialState, {
  ON_CHANGE: (state, payload) => {
  	const data = { ...state.data, ...payload };
  	const newState = { ...state, data };
  	return { ...newState, errorMessages: [], results: calculate(data), isDisabled: isDisabledSubmit(newState) };
	},
	ON_LOAD: (state, payload) => {
		return { ...state, isLoading: payload };
	},
	ON_SUBMIT: (state) => {
  	const { submitForm = {} } = { ...state.data };
		const errorMessages = validate(submitForm);
		return errorMessages.length ? { ...state, errorMessages } : { ...state };
	},
	CLEAR_SUBMIT_FORM: (state) => {
		return { ...state, data: { ...state.data, submitForm: initialState.data.submitForm }, isDisabled: false };
	}
});



// WEBPACK FOOTER //
// ./src/reducers/CalculatorReducer.js